import type { ComponentProps } from 'react'

import { CurrencyInput, FormItem } from '@monthio/design-system'
import { useIntlConfig } from '@monthio/react-components'
import { useField } from 'formik'
import { useTranslation } from 'react-i18next'

type FormikCurrencyInputProps = Omit<
	ComponentProps<typeof CurrencyInput>,
	'currency' | 'locale'
> & {
	fieldName: string
	label: string
	hintText?: string
	isRequired?: boolean
	additionalOnChange?: (value: number | undefined) => void
}

export const FormikCurrencyInput = ({
	fieldName,
	label,
	hintText,
	isRequired,
	onBlur,
	additionalOnChange,
	onChange,
	value,
	...props
}: FormikCurrencyInputProps) => {
	const { t } = useTranslation()
	const [field, meta, { setValue, setTouched }] = useField<number | undefined>(
		fieldName,
	)

	const intlConfig = useIntlConfig()

	return (
		<FormItem
			label={label}
			isRequired={isRequired}
			requiredText={t('required')}
			errorText={meta.touched ? meta.error : undefined}
			hintText={hintText}
		>
			<CurrencyInput
				{...props}
				value={value ?? field.value}
				onChange={
					onChange ??
					((value) => {
						additionalOnChange?.(value)
						setValue(value)
					})
				}
				onBlur={(e) => {
					onBlur?.(e)
					setTouched(true)
				}}
				currency={intlConfig.currency ?? 'DKK'}
				locale={intlConfig.locale}
			/>
		</FormItem>
	)
}
